var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"demo"},[_c('button',{on:{"click":_vm.onClick}},[_vm._v("click")]),_c('rich-text',{attrs:{"jsonText":_vm.jsonText,"readonly":""}}),_c('rich-text',{staticClass:"demo",attrs:{"jsonText":_vm.jsonText,"errors":_vm.errors},on:{"change":_vm.handleChange,"focus":_vm.handleFocus,"blur":_vm.handleBlur}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }